import {
	type ActionKeys,
	JIRA_PLANS_CREATE_WORK_ITEM_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import type {
	ActionRendererKeyToPayload,
	ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';
import { type MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import { jiraPlansActionData } from '../../common/utils/plan-action-data';

const isCreateWorkItemAction = (action: MessageAction): boolean =>
	jiraPlansActionData.isPlanActionKeyForRenderer(action.key, JIRA_PLANS_CREATE_WORK_ITEM_KEY);

export const filterCreateWorkItemActions = (
	actions: MessageAction[],
): ActionWith<ActionRendererKeyToPayload[typeof ActionKeys.JiraPlansCreateWorkItem]>[] => {
	const filteredActions = actions.filter(isCreateWorkItemAction);
	return filteredActions as ActionWith<
		ActionRendererKeyToPayload[typeof ActionKeys.JiraPlansCreateWorkItem]
	>[];
};
